import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const SelectedFacility = props => {
  const { facility } = props;
  return (
    <>
      <p>This is the new facility you have chosen.</p>
      <p className="vads-u-border-left--4px">
        <span className="vads-u-margin-left--2p5">{`${facility}`}</span>
      </p>
    </>
  );
};

SelectedFacility.propTypes = {
  facility: PropTypes.string,
};

const mapStateToProps = state => ({
  facility: state.form.data.school,
});

export default connect(mapStateToProps)(SelectedFacility);
